export const getParticipantsChannel = (tournamentId: string) => {
    if (tournamentId) {
        return `${tournamentId}_PARTICIPANTS_JSON`;
    }
    return undefined;
};

export const getTimingChannel = (tournamentId: string, rsc: string) => {
    if (tournamentId && rsc) {
        return `${tournamentId}_TIMING_${rsc}_JSON`;
    }
    return undefined;
};

export const getStandingDataChannel = (tournamentId: string) => {
    if (tournamentId) {
        return `${tournamentId}_STANDINGDATA_JSON`;
    }
    return undefined;
};

export const getCompStructChannel = (tournamentId: string) => {
    if (tournamentId) {
        return `${tournamentId}_COMPSTRUCT_JSON`;
    }
    return undefined;
};
